import Icon from '@/components/ui/AppIcon';

interface DocumentCardProps {
  title: string;
  description: string;
  iconName: string;
  isRequired: boolean;
}

export default function DocumentCard({ title, description, iconName, isRequired }: DocumentCardProps) {
  return (
    <div className="bg-card border border-border rounded-xl p-6 hover:shadow-soft transition-all duration-300">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name={iconName as any} size={24} variant="outline" className="text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 mb-2">
            <h4 className="font-headline font-semibold text-lg text-foreground">{title}</h4>
            {isRequired && (
              <span className="px-2 py-0.5 bg-error/10 text-error text-xs font-body font-medium rounded">
                Required
              </span>
            )}
          </div>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}